import type { ObjectId } from '@freightview/object-id'

import type {
  AccountUserListingResponse,
  AccountUserSource,
  UserAccess,
  UserMarkup,
  Workflow,
} from '@fv/models'

export type AccountUser = {
  _id: ObjectId
  created: Date
  username: string
  apiKey?: string
  firstName: string
  lastName: string
  title?: string
  phone?: string
  owner: boolean
  lastLogin?: Date
  access?: UserAccess
  workflows?: Workflow[]
  markup?: UserMarkup
  removed?: boolean
  registered?: Date
  stats?: UserStats
  source?: AccountUserSource
  disabled?: boolean
  marketing?: {
    subscribed?: boolean
  }
}

export interface UserSpotQuoteStats {
  quoteCount?: number
  bookedCount?: number
  lastQuote?: Date
  lastBooked?: Date
}
export interface UserLtlQuoteStats {
  quotedNmfc?: number
  count?: number
  last?: Date
  api?: number
  lastAPI?: Date
}
export interface UserLtlBookStats {
  count?: number
  api?: number
  last?: Date
  lastAPI?: Date
}
export interface UserParcelStats {
  quoteCount?: number
  bookedCount?: number
  quotedCountAPI?: number
  bookedCountAPI?: number
  lastQuote?: Date
  lastQuotedAPI?: Date
  lastBooked?: Date
  lastBookedAPI?: Date
}
export interface UserTruckloadStats {
  count?: number
  bookedCount?: number
  quotedCountAPI?: number
  bookedCountAPI?: number
  lastCreated?: Date
  lastQuotedAPI?: Date
  lastBooked?: Date
  lastBookedAPI?: Date
}

export interface UserStats {
  spotQuotes?: UserSpotQuoteStats
  quotes?: UserLtlQuoteStats
  booked?: UserLtlBookStats
  parcel?: UserParcelStats
  truckload?: UserTruckloadStats
}

export type AdminAccountUserModel = AccountUserListingResponse &
  Pick<AccountUser, 'marketing' | 'stats' | 'disabled'>

import {
  vBoolean,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
} from '../validation/index.ts'

export const updateOwnerBodySchema = vObject({
  userId: vObjectId(),
})
export type UpdateOwnerBody = vOutput<typeof updateOwnerBodySchema>

export const updateMarketingBodySchema = vObject({
  subscribed: vBoolean(),
})
export type UpdateMarketingBody = vOutput<typeof updateMarketingBodySchema>

export const accountUsersQuerySchema = vObject({
  includeVendorUsers: vOptional(vBoolean()),
})
export type AccountUsersQuery = vOutput<typeof accountUsersQuerySchema>
